import { Component } from '@angular/core';

@Component({
  selector: 'app-scatter-chart',
  template: '<app-chart-output></app-chart-output>',
})
export class ScatterChartComponent {

}
